import { c as _c } from "react/compiler-runtime";
import { Table, type TableRow } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
import type { BusinessInsightDisplayOptions } from '../../../../../../onboarding-business-insight';
import type { FormattedName } from '../../../../../../onboarding-business-insight.types';
import MobileRow from './components/mobile-row';
import Row from './components/row';
type BusinessNameListProps = {
  data: FormattedName[];
  onOpen: (id: string) => void;
  displayOptions?: BusinessInsightDisplayOptions;
};
const BusinessNameList = t0 => {
  const $ = _c(19);
  const {
    data,
    onOpen,
    displayOptions
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.businessDetails.name.table"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const isMobile = useMobileLayout();
  let t2;
  if ($[1] !== isMobile || $[2] !== t) {
    t2 = isMobile ? [{
      text: t(_temp)
    }] : [{
      text: t(_temp2),
      width: "65%"
    }, {
      text: t(_temp3),
      width: "35%"
    }];
    $[1] = isMobile;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const columns = t2;
  let t3;
  if ($[4] !== isMobile || $[5] !== onOpen) {
    t3 = t4 => {
      const {
        item
      } = t4;
      return isMobile ? <MobileRow businessName={item} onOpen={onOpen} /> : <Row businessName={item} onOpen={onOpen} />;
    };
    $[4] = isMobile;
    $[5] = onOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const renderTr = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = displayOptions?.tableVariant;
  let t7;
  if ($[11] !== columns || $[12] !== data || $[13] !== isMobile || $[14] !== renderTr || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <Table aria-label={t4} columns={columns} emptyStateText={t5} getKeyForRow={_temp6} hideThead={isMobile} items={data} renderTr={renderTr} variant={t6} />;
    $[11] = columns;
    $[12] = data;
    $[13] = isMobile;
    $[14] = renderTr;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default BusinessNameList;
function _temp($) {
  return $.header.name;
}
function _temp2($_0) {
  return $_0.header.name;
}
function _temp3($_1) {
  return $_1.header.type;
}
function _temp4($_2) {
  return $_2.ariaLabel;
}
function _temp5($_3) {
  return $_3.emptyState;
}
function _temp6(businessName) {
  return `${businessName.name} ${businessName.kind}`;
}